import React, { useState } from "react";
import { connect } from "react-redux";
import { css } from "emotion";

import { formatPhone } from "../../../../../shared/utils";
import { boxInfoFinishedOfferStyle } from "./style";
import { useNewOffer } from "../../../../../context/new-offer";
import { setFidelityPhoneByFidelityId } from "../../../../../shared/requests-api";


import { MINIMAL_MILES_ADVANCED_AVERAGE } from "../../../../../../../offers/js/shared/enums";

import { refreshOffers } from "../../../../../actions";

import ModalLatamPhone from "../../../../../../shared/create-offer/ModalPhoneLatam/ModalLatamPhone";
import {GOL_ACRONYM, GOL_TWO_FACTOR_MESSAGE} from "../../../../../../../js/shared/constants";

const EditInfoFinishedOffer = ({ refreshOffers, typePhoneLatam }) => {
	const {
		currentProgram,
		editOffer: { forwardPayment, paymentDeadline, workingDays },
		offerData,
		loyaltyData,
		setLoyaltyData,
		phoneMultiplus
	} = useNewOffer();

	const { quant } = offerData?.data;
	const { phone, isMaxPhone, id } = loyaltyData.data;
	const phoneMMSuggestion = phoneMultiplus;

	const [showModalPhone, setShowModalPhone] = useState(false);

	const onChangePhone = phone => {
		let phoneMax = 0;
		setFidelityPhoneByFidelityId(id, phone).then(() => {
			if (phoneMMSuggestion === phone) {
				phoneMax = 1;
			} else {
				phoneMax = 0;
			}
			setLoyaltyData({
				...loyaltyData,
				data: { ...loyaltyData.data, isMaxPhone: phoneMax, phone: phone }
			});

			refreshOffers();

			setShowModalPhone(false);
		});
	};

	const isLatam = () => {
		return currentProgram.id === 3 || currentProgram.id === 1;
	};

	const isSmiles = () => {
		return currentProgram.id === 4;
	}

	const isWrongLatamPhone = isLatam() && (isMaxPhone === 0 || isMaxPhone === -1);

	const isShowSmilesWarning = isSmiles() && (forwardPayment || quant < MINIMAL_MILES_ADVANCED_AVERAGE);

	const getPeriod = () => {
		let period = `${paymentDeadline} ${paymentDeadline > 1 ? 'dias' : 'dia'}`;
		
		if(workingDays) 
			period = `${period} ${paymentDeadline > 1 ? 'úteis' : 'útil'}`;

		return period;
	}

	return (
		<div
			className={css`
				${boxInfoFinishedOfferStyle}
			`}
		>
			<p className="title">Informações importantes</p>
			{currentProgram?.acronym === GOL_ACRONYM ? <p>{GOL_TWO_FACTOR_MESSAGE}</p> : null}
			{isWrongLatamPhone && typePhoneLatam === 0 ? (
				<>
					<p>
						• A cada emissão de passagem com suas milhas, a Latam envia um código SMS para o
						telefone celular cadastrado no programa
					</p>
					<p>
						• As suas milhas <strong>não estarão disponíveis</strong> para venda até que o telefone{" "}
						<strong>{formatPhone(phoneMMSuggestion)}</strong> da MaxMilhas seja incluído no seu
						cadastro da Latam Pass.
					</p>
					<p>
						• Após inserir o telefone indicado acima no Latam Pass,
						<a
							onClick={() => {
								setShowModalPhone(true);
							}}
							className="area-text--link"
						>
							<strong> clique aqui </strong>
						</a>
						e digite esse mesmo telefone para sabermos que o procedimento foi concluído.
					</p>
				</>
			) : (
				<>
					{isLatam() && typePhoneLatam === 0 ? (
						<p>
							• Para que a sua oferta seja aprovada, o campo do telefone celular da sua conta Latam
							Pass deve ser preenchido com o mesmo número indicado no cadastro de oferta da
							MaxMilhas.
						</p>
					) : (
						<p>• Você pode adicionar uma única oferta por programa de fidelidade.</p>
					)}
					{isShowSmilesWarning ? ( 
						<p>
							• Se você for categoria Diamante, poderemos emitir passagens com redução de milhas na Tarifa Especial Diamante (teto) disponíveis em sua conta.
						</p>
					) 
					:
						null
					}
					{forwardPayment ? (
						<p>
							• O pagamento pelas milhas será feito em {getPeriod()} a partir da aprovação da oferta.
							Vale lembrar que, depois de aprovada, a emissão de passagens com as milhas vendidas é
							feita de forma parcial, de acordo com a quantidade de milhas necessárias para o voo
							escolhido pelo passageiro. {`${!workingDays && `Caso o ${paymentDeadline}º dia seja um fim de semana ou feriado, 
							o pagamento será feito no dia útil seguinte.`}`}
						</p>
					) : (
						<>
							<p>
								• O pagamento pelas suas milhas será feito em até <strong>{paymentDeadline || '60'} dias corridos</strong>,
								a partir da data de emissão da passagem. Caso o {paymentDeadline || '60'}º dia seja um fim de semana ou
								feriado, o pagamento será feito no dia útil seguinte.
							</p>
							<p>
								• A venda de milhas da sua oferta é feita de forma parcial, de acordo com a
								quantidade de milhas necessárias para o voo escolhido pelo comprador.
							</p>
						</>
					)}
				</>
			)}
			<ModalLatamPhone
				show={showModalPhone}
				close={() => setShowModalPhone(false)}
				confirm={onChangePhone}
				phoneSugestion={phoneMMSuggestion}
				phone={phone}
				updateLatamPhone
			/>
		</div>
	);
};

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => {
	return {
		refreshOffers: () => dispatch(refreshOffers())
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(EditInfoFinishedOffer);
